export default __webpack_public_path__ + "img/PosterWaterfall3ColCropped.cbf739f5.png";